const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000/api';

export const API_ENDPOINTS = {
  DEMO: {
    GET: `${API_BASE_URL}/demo`,
    GET_AIS: `${API_BASE_URL}/demo/ais`,
  },
  AUTH: {
    LOGIN: `${API_BASE_URL}/v1/auth/login`,
    REFRESH_TOKEN: `${API_BASE_URL}/v1/auth/refresh_token`,
    REGISTER: `${API_BASE_URL}/v1/auth/register`,
  },
  USER: {
    CREATE: `${API_BASE_URL}/v1/user`,
    GET_ALL: `${API_BASE_URL}/v1/user`,
    GET_ONE: (id) => `${API_BASE_URL}/v1/user/${id}`,
    UPDATE: (id) => `${API_BASE_URL}/v1/user/${id}`,
    DELETE: (id) => `${API_BASE_URL}/v1/user/${id}`,
  },
  USER_CLIENT: {
    GET_ME: `${API_BASE_URL}/v1/user-client/me`,
    GET_ALL: `${API_BASE_URL}/v1/user-client`,
    CREATE: `${API_BASE_URL}/v1/user-client`,
    GET_ONE: (id) => `${API_BASE_URL}/v1/user-client/${id}`,
    UPDATE: (id) => `${API_BASE_URL}/v1/user-client/${id}`,
    DELETE: (id, clientId) => `${API_BASE_URL}/v1/user-client/${id}/${clientId}`,
  },
  USER_ACTIVITY: {
    CREATE: `${API_BASE_URL}/v1/user-activity`,
    GET_ALL: `${API_BASE_URL}/v1/user-activity`,
    GET_ONE: (id) => `${API_BASE_URL}/v1/user-activity/${id}`,
    DELETE: (id) => `${API_BASE_URL}/v1/user-activity/${id}`,
  },
  ROLE: {
    CREATE: `${API_BASE_URL}/v1/role`,
    GET_ALL: `${API_BASE_URL}/v1/role`,
    GET_ONE: (id) => `${API_BASE_URL}/v1/role/${id}`,
    UPDATE: (id) => `${API_BASE_URL}/v1/role/${id}`,
    DELETE: (id) => `${API_BASE_URL}/v1/role/${id}`,
  },
  ROLE_PERMISSION: {
    CREATE: `${API_BASE_URL}/v1/role-permission`,
    GET_ALL: `${API_BASE_URL}/v1/role-permission`,
    GET_ONE: (id) => `${API_BASE_URL}/v1/role-permission/${id}`,
    GET_BY_ROLE_ID: (id) => `${API_BASE_URL}/v1/role-permission/by-role/${id}`,
    UPDATE: (id) => `${API_BASE_URL}/v1/role-permission/${id}`,
    DELETE: (id) => `${API_BASE_URL}/v1/role-permission/${id}`,
  },
  CLIENT: {
    CREATE: `${API_BASE_URL}/v1/client`,
    GET_ALL: `${API_BASE_URL}/v1/client`,
    GET_ME: `${API_BASE_URL}/v1/client/me`,
    GET_ONE: (id) => `${API_BASE_URL}/v1/client/${id}`,
    UPDATE: (id) => `${API_BASE_URL}/v1/client/${id}`,
    DELETE: (id) => `${API_BASE_URL}/v1/client/${id}`,
  },
  FEATURE: {
    CREATE: `${API_BASE_URL}/v1/feature`,
    GET_ALL: `${API_BASE_URL}/v1/feature`,
    GET_ONE: (id) => `${API_BASE_URL}/v1/feature/${id}`,
    UPDATE: (id) => `${API_BASE_URL}/v1/feature/${id}`,
    DELETE: (id) => `${API_BASE_URL}/v1/feature/${id}`,
  },
  CHANNEL: {
    CREATE: `${API_BASE_URL}/v1/channel`,
    GET_ALL: `${API_BASE_URL}/v1/channel`,
    DELETE: `${API_BASE_URL}/v1/channel`,
    GET_PLAY_HLS: (suuid) => `${API_BASE_URL}/v1/channel/play/hls/${suuid}/index.m3u8`,
    GET_PLAY_HLS_TS: (suuid, seq) => `${API_BASE_URL}/v1/channel/play/hls/${suuid}/segment/${seq}/file.ts`,
  },
  SENSOR: {
    CREATE: `${API_BASE_URL}/v1/sensor`,
    GET_ALL: `${API_BASE_URL}/v1/sensor`,
    GET_ONE: (id) => `${API_BASE_URL}/v1/sensor/${id}`,
    UPDATE: (id) => `${API_BASE_URL}/v1/sensor/${id}`,
    DELETE: (id) => `${API_BASE_URL}/v1/sensor/${id}`,
  },
  SENSOR_TYPE: {
    CREATE: `${API_BASE_URL}/v1/sensor-type`,
    GET_ALL: `${API_BASE_URL}/v1/sensor-type`,
    GET_ONE: (id) => `${API_BASE_URL}/v1/sensor-type/${id}`,
    UPDATE: (id) => `${API_BASE_URL}/v1/sensor-type/${id}`,
    DELETE: (id) => `${API_BASE_URL}/v1/sensor-type/${id}`,
  },
  VESSEL: {
    GET_ALL: `${API_BASE_URL}/v1/vessel`,
    GET_ONE: (mmsi) => `${API_BASE_URL}/v1/vessel/${mmsi}`,
    GET_ONE_BY_MMSI_AND_CLIENTID: (mmsi, clientId) => `${API_BASE_URL}/v1/vessel/${mmsi}/${clientId}`,
  },
};

export default API_ENDPOINTS;
